import { render, staticRenderFns } from "./Pop.vue?vue&type=template&id=da2c8770&scoped=true&"
import script from "./Pop.vue?vue&type=script&lang=js&"
export * from "./Pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2c8770",
  null
  
)

export default component.exports